export default __webpack_public_path__ + "static/media/icons8-shpatel.a21ffbe7.svg";